<template>
  <div class="video off"></div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/OffVideo.vue